export const Navbar = () => {
    return (
        <>
            <nav className="navbar navbar-expand-lg sticky-top navbar-dark" style={{ backgroundColor: "#0b111b" }}>
                <div className="container-fluid">
                   
                    <span className="navbar-brand brand-margin ps-4">Mohit Sehrawat</span>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ">
                            
                            <li className="nav-item">
                                <a className="nav-link" href="#about">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#skills">Skills</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#projects">Project</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#contact">Contact</a>
                            </li>
                            <li className="nav-item me-5">
                                <a className="nav-link" href="https://drive.google.com/file/d/1BPPSerFjed-o9VGkwFtZyvbu_65r8B4Y/view?usp=sharing" target="_blank" rel="noreferrer">Resume</a>
                            </li>
                            <li className="nav-item">
                                <a href="https://github.com/m-sehrawat" target="_blank" rel="noreferrer"><img className="icon mt-1" src="github-icon.png" alt="icon" /></a>
                                <a href="https://www.linkedin.com/in/m-sehrawat/" target="_blank" rel="noreferrer"><img className="icon mt-1 ms-3" src="linkedin-icon.png" alt="icon" /></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};